module.exports = __webpack_public_path__ + "static/img/14.24bd51ca.png";